<template>
    <v-container class="pa-5" fluid>
        <page-title>
            Czas pracy
        </page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-clipboard-list-outline
                                    </v-icon>
                                    Rozliczenia czasu pracy
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Lista rozliczenia czasu pracy.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisReportsReportsDailyReportsShiftSummaries')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-clipboard-list-outline
                                    </v-icon>
                                    Rankingi
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Lista rankingów.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisReportsUsersRanking')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-card
                                class="mx-auto"
                            >
                                <v-card-title>
                                    <v-icon
                                        left
                                        large
                                    >
                                        mdi-clipboard-list-outline
                                    </v-icon>
                                    Podsumowania / Raporty
                                </v-card-title>
                                <v-card-text>
                                    <div class="text--primary">
                                        Lista raportów.
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                        text
                                        color="info"
                                        @click="openReport('reportingAndAnalysisReportsReportsSummaries')"
                                    >
                                        Otwórz
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'Reports',
    components: {
        PageTitle,
    },
    methods: {
        openReport(report) {
            this.$router.push({name: report})
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>